import Shop from './Shop';
export default function Sgrassatori() {
  return <Shop defaultCategory="sgrassatori" title="Sgrassatori profumati ESSENYA" description="Efficaci contro lo sporco quotidiano, piacevoli da usare e pensati per lasciare sulle superfici una sensazione di pulito fresco." />;
}
